import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import useFileImportStore from "../../stores/fileImportStore";

export default function FinishImport() {
  const location = useLocation();
  const navigate = useNavigate();
  const successfulImports = useFileImportStore((s) => s.successfulImports);
  useEffect(() => {
    if (location && location.state) {
      const { action } = location.state;
      if (action === "continue") {
        useFileImportStore.getState().incrementBOMImportIndex();
        navigate("/dashboard/import-bom-csv/");
      } else if (action === "summary") {
        Swal.fire({
          title: "Success",
          text: `Imported ${successfulImports.length} BOMs.`,
        }).then(() => {
          useFileImportStore.getState().clearState(true);
          navigate("/dashboard", { replace: true });
        });
      } else {
        useFileImportStore.getState().clearState(true);
        navigate(`/dashboard/bom/${location.state.bomId}/`);
      }
    }
  }, [location, navigate, successfulImports]);

  return (
    <div className="container pt-5">
      <div className="row">
        <div className="d-flex justify-content-center">
          <LoadingSpinner />
        </div>
      </div>
    </div>
  );
}
